import Service from "../../../Services/index";

const ProductType = {
    namespaced: true,
    state: {
        data: [],
        product: [],
        productTypeSpecial: [],
        productSKU: []
    },
    mutations: {
        GET_PRODUCT_TYPE: (state, res) => {
            state.data = res;
        },
        GET_PRODUCT: (state, res) => {
            state.product = res;
        },
        GET_PRODUCT_SPECIAL: (state, res) => {
            state.productTypeSpecial = res;
        },
        GET_PRODUCT_SKU: (state, res) => {
            state.productSKU = res;
        }
    },
    actions: {
        get({ commit }) {
            return Service.productType.getProductType().then(response => {
                commit("GET_PRODUCT_TYPE", response);
                return response;
            });
        },
        productTypeSpecial({ commit }) {
            return Service.productType.productTypeSpecial().then(response => {
                commit("GET_PRODUCT_SPECIAL", response);
            });
        },
        productForStock({ commit }) {
            return Service.productType.getProduct().then(response => {
                commit("GET_PRODUCT", response);
                return response;
            });
        },
        productSKU({ commit }) {
            return Service.productType.getProduct().then(response => {
                commit("GET_PRODUCT_SKU", response);
                return response;
            });
        }
    }
};

export default ProductType;
